// extracted by mini-css-extract-plugin
export default {"checkbox":"styles__checkbox___V8FA1"};